import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["expansion", { 'expanded': _ctx.isExpanded.value }]),
    ref: "root"
  }, [
    _createVNode(_Transition, {
      name: "expansion",
      onEnter: _ctx.enter,
      onAfterEnter: _ctx.afterEnter,
      onLeave: _ctx.leave
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, _ctx.isExpanded.value]
        ])
      ]),
      _: 3
    }, 8, ["onEnter", "onAfterEnter", "onLeave"])
  ], 2))
}